export const LOAD_FACETS = 'loadFacets'
